import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useMediaStore = defineStore('media', createBaseStore('/bilder/',
        {},
        {
            async addItem(image) {
                try {
                    const response = await this.axios.post("/bilder/", image, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                    this.data.push(response.data);
                } catch (e) {
                    console.log(e);
                }
            },
        },
        {}
    )
)
